import React from 'react';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';

interface PageLoaderProps {}

const PageLoader: React.FC<PageLoaderProps> = () => {
    return (
        <Backdrop open={true} data-testid="backdrop">
            <CircularProgress
                size={60}
                sx={{ color: 'common.primary' }}
                thickness={2}
                data-testid='circular-progress'
            />
        </Backdrop>
    );
};

export default PageLoader;
